import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { CreateModal } from "../../../shared/components/Modal";
import { useGetContato } from "../hooks/useGetContatos";
import usePutContato from "../hooks/usePutContato";
import { ContatoTypes } from "../types";
import { TabsInfoContato } from "./TabsInfoContato";

interface EditContatoModalProps {
  onCancel: () => void;
  deleteModal: () => void;
  visible: boolean;
  contatoId: number;
}

export function EditContatoModal({
  onCancel,
  visible,
  deleteModal,
  contatoId: id,
}: EditContatoModalProps) {
  const { register, handleSubmit, reset, control } = useForm<ContatoTypes>();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [haveMovToPrint, setHaveMovToPrint] = useState<boolean>(false);
  const [contato, setContato] = useState<ContatoTypes>();
  const { data: contatoData } = useGetContato(id);


  const { mutate: salvarEdicaoContato, isLoading: LoadingButton } = usePutContato(() => handleCloseLaterSave());

  useEffect(() => {
    contatoData && setContato(contatoData);
  }, [contatoData]);

  useEffect(() => {
    reset({
      ...contatoData,
      ClienteId: contatoData?.ClienteId?.toString(),
    });
  }, [contatoData, reset]);

  async function onSubmit(data: ContatoTypes) {
    navigator.onLine && salvarEdicaoContato({
      contatoAtual: contato ? contato : contatoData,
      id,
      data,
    });

    if (!navigator.onLine) {
      Swal.fire({
        title: 'Ocorreu um erro',
        text: 'Por favor, verifique sua conexão com a internet e tente novamente.',
        icon: 'error',
        position: 'center',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#F27474'
      })
    }
  }

  function handleCloseLaterSave() {
    onCancel();
    reset();
    setDisabled(!disabled);
  }

  return (
    <>
      <CreateModal
        title="Visualizar Contato"
        isModalOpen={visible}
        disabled={disabled}
        onCancel={() => {
          onCancel()
          localStorage.removeItem('movimentos')
        }}
        onSubmit={handleSubmit(onSubmit)}
        deleteOpenModal={() => {
          deleteModal();
        }}
        setDisabled={() => setDisabled(!disabled)}
        closable
        hasId
        movToPrint={haveMovToPrint}
        isLoading={LoadingButton}
      >
        {contato && (
          <TabsInfoContato
            register={register}
            inputDisabled={disabled}
            dataSourceContato={contatoData}
            setHaveMovToPrint={setHaveMovToPrint}
            control={control}
            ContatoId={id}
          />
        )}
      </CreateModal>
    </>
  );
}
